import { useEffect, useState } from 'react';
import axios from 'axios';

// URLs from environment variables or fallback
const WEBSOCKET_URL = process.env.REACT_APP_LIVES_WS_URI || 'wss://7zfimj8vbrgpdu-8080.proxy.runpod.net';

export function useTranscript(liveId, isOnLive, info) {
  const [transcripts, setTranscripts] = useState([]);
  const [loadingTranscript, setLoadingTranscript] = useState(false);

  // Fetch archived transcript if not live
  useEffect(() => {
    if (!isOnLive && liveId && info?.TranscriptUrl) {
      setLoadingTranscript(true);
      const plainAxios = axios.create({});

      plainAxios
        .get(info.TranscriptUrl)
        .then((res) => {
          const jsonlData = res.data;
          const transcriptArray = jsonlData
            .split('\n')
            .filter((line) => line.trim() !== '')
            .map((line) => JSON.parse(line));
          setTranscripts(transcriptArray);
          setLoadingTranscript(false);
        })
        .catch((err) => {
          console.error('Error fetching archived transcript:', err);
          setLoadingTranscript(false);
        });
    }
  }, [isOnLive, liveId, info]);

  // Open WebSocket for live transcript
  useEffect(() => {
    console.log('isOnLive', isOnLive);
    console.log('liveId', liveId);
    if (isOnLive && liveId) {
      const wsUri = `${WEBSOCKET_URL}/ws?videoId=${liveId}`;
      console.log('wsUri', wsUri);
      const ws = new WebSocket(wsUri);

      ws.onopen = () => {
        console.log('WebSocket connected for transcripts');
      };

      ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        // Replace full transcript or append new transcript item
        if (data.type === 'fullTranscript') {
          setTranscripts(data.data);
        } else {
          setTranscripts((prev) => [...prev, data]);
        }
      };

      ws.onerror = (err) => {
        console.error('WebSocket error:', err);
      };

      // Cleanup WebSocket on unmount
      return () => ws.close();
    }
  }, [isOnLive, liveId]);

  return { transcripts, loadingTranscript };
}
